import merge from 'deepmerge';

import { findNextStepByOrder } from './findNextStepByOrder';

import type { StepState } from '../types';
import type { StepProps } from '../useStepForm';

export function calculateNextStep(
  history: StepState[],
  activeId: string,
  steps: StepProps[],
): string {
  const [cumulativeFormData] = history.reduce(
    ([formData, foundCurrent], step, i) => {
      if (foundCurrent) return [formData, foundCurrent];
      if (i === history.length - 1 && step.id !== activeId) return [{}, false];

      const newFormData = {
        ...formData,
        ...(!step.skipped && step.formData),
      };
      const newFoundCurrent = step.id === activeId;
      return [newFormData, newFoundCurrent];
    },
    [{}, false],
  );

  const nextStep = findNextStepByOrder(steps, activeId, cumulativeFormData);
  return nextStep?.id || activeId;
}

export function accumulateFormData(history: StepState[]): Record<string, unknown> {
  return history.reduce((formData, stepData) => {
    const result = merge(formData, !stepData.skipped ? stepData.formData : {});
    return result;
  }, {});
}
